import { useEffect, useState } from 'react';

/**
 * Custom hook for responsive design that detects if the window matches a media query
 * @param query Media query string (e.g. '(max-width: 768px)')
 * @returns Boolean indicating if the media query matches
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    // Create media query list and check initial match
    const mediaQuery = window.matchMedia(query);
    setMatches(mediaQuery.matches);

    // Define handler to update state
    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Add event listener
    mediaQuery.addEventListener('change', handler);

    // Cleanup on unmount
    return () => {
      mediaQuery.removeEventListener('change', handler);
    };
  }, [query]);

  return matches;
}